import {Injectable} from '@angular/core';
import {Observable, catchError, map} from 'rxjs';
import {HttpService} from '../http.service';
import {HttpErrorHandlerService} from '../http-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private httpService: HttpService,
    private errorHandler: HttpErrorHandlerService
  ) {
  }

  /**
   * Obtiene el perfil público del usuario
   * @param userId ID del usuario (opcional, si no se proporciona, retorna el perfil del usuario actual)
   * @returns Observable con los datos del perfil público
   */
  getPublicProfile(): Observable<any> {
    return this.httpService.get('profiles/public').pipe(
      map((response: any) => {
        return response.data || {};
      }),
      catchError((error) => this.errorHandler.handleError(error, false))
    );
  }

  /**
   * Actualiza el perfil público del usuario
   * @param profileData Datos del perfil a actualizar
   * @returns Observable con la respuesta del servidor
   */
  updatePublicProfile(profileData: any): Observable<any> {
    return this.httpService.put('profiles/public', profileData).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  /**
   * Obtiene la información de la cuenta del usuario actual
   * @returns Observable con los datos de la cuenta
   */
  getAccountInfo(): Observable<any> {
    return this.httpService.get('profiles/account').pipe(
      map((response: any) => {
        return response.data || {};
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  /**
   * Actualiza la información de la cuenta del usuario
   * @param accountData Datos de la cuenta a actualizar
   * @returns Observable con la respuesta del servidor
   */
  updateAccountInfo(accountData: any): Observable<any> {
    return this.httpService.put('profiles/account', accountData).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  /**
   * Actualiza el idioma del perfil del usuario autenticado
   * PATCH /profiles/language
   */
  updateLanguage(language: string): Observable<any> {
    return this.httpService.patch('profiles/language', { language }).pipe(
      map((response: any) => response || {}),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getProfile(userId: number): Observable<any> {
    return this.httpService.get(`profile/public/${userId}`).pipe(
      map((response: any) => {
        return response.data || {};
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
}
